import {FC} from 'react';

import {Box, Stack, Typography} from '@mui/material';

const HasNoApiAccess: FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        textAlign: 'center',
      }}
    >
      <Stack direction="column" spacing={4} sx={{alignItems: 'center'}}>
        <Stack direction="column" sx={{textAlign: 'center'}} spacing={3}>
          <Typography variant="h4">Технические работы</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default HasNoApiAccess;
